export const isProcessingSelector = state => state.api.authentication.isProcessing;